import { createApiCall } from './index'

export interface IntegrationProductData {
  id: string
  title: string
  sku?: string
  description?: string
  price?: number
  images: string[]
  created_at: Date
  updated_at: Date
  imported?: boolean
  category_id?: string | null
  // Forwarded back to the API on import so the created product keeps its storefront
  // link. The server resolves the value; the client only relays it.
  product_url?: string | null
}

export interface AddProductsFromIntegrationRequest {
  provider: string
  integration_products: IntegrationProductData[]
  product_type?: string
  quantity?: number
  available?: boolean
}

export interface BulkOperationResult {
  success: boolean
  product?: {
    id: string
    company_id: string
    type: string | null
    title: string
    sku: string | null
    images: (string | null)[]
    description: string | null
    details: string | null
    quantity: number
    available: boolean
    manufactured_at: Date | null
    created_at: Date
    updated_at: Date | null
  }
  error?: string
  integrationProductId: string
}

export interface AddProductsFromIntegrationResponse {
  results: BulkOperationResult[]
  totalAttempted: number
  totalSuccessful: number
  totalFailed: number
}


export const productIntegrationApi = {
  addProductsFromIntegration: async ({
    provider,
    ...data
  }: AddProductsFromIntegrationRequest): Promise<AddProductsFromIntegrationResponse> => {
    const response = await createApiCall({
      method: 'POST',
      url: `/products/admin/from-integration/${provider}`,
      data,
    })

    return response.data
  },
}

